/*---------------------------------------------------------------------------------------------
	 *  Copyright (c) Microsoft Corporation. All rights reserved.
	 *  Licensed under the MIT License. See License.txt in the project root for license information.
	 *--------------------------------------------------------------------------------------------*/

	// This file is generated by build/npm/postinstall.js. Do not edit.
self.webPackagePaths = {
  "@microsoft/1ds-core-js": "dist/ms.core.min.js",
  "@microsoft/1ds-post-js": "dist/ms.post.min.js",
  "@vscode/iconv-lite-umd": "lib/iconv-lite-umd.js",
  "@vscode/vscode-languagedetection": "dist/lib/index.js",
  "jschardet": "dist/jschardet.min.js",
  "tas-client-umd": "lib/tas-client-umd.js",
  "vscode-oniguruma": "release/main.js",
  "vscode-textmate": "release/main.js",
  "xterm": "lib/xterm.js",
  "xterm-addon-search": "lib/xterm-addon-search.js",
  "xterm-addon-unicode11": "lib/xterm-addon-unicode11.js",
  "xterm-addon-webgl": "lib/xterm-addon-webgl.js",
  "@microsoft/dynamicproto-js": "lib/dist/umd/dynamicproto-js.min.js",
  "@microsoft/applicationinsights-shims": "dist/umd/applicationinsights-shims.min.js",
  "@microsoft/applicationinsights-core-js": "browser/applicationinsights-core-js.min.js"
};